import request from '@/utils/request';

const PATH = '/reservation-item';

/* eslint-disable */
export const defaultReservationItem = () => {
  return {
    categoryUid: '', // 카테고리 고유값
    facilityCategoryUid: null,
    name: '', // 시설명
    subName: '',
    typeName: '', // 분류 이름
    typeUid: '',
    maxPeople: 1, // 정원
    limit: 0, // 최대인원수
    approvalStatus: false, // 심사여부
    institutionUid: null,
    managerUid: null,
    hourUnitStatus: 0,
    groupMaxPeople: 0,
    detailDescription: '',
    restriction: '',
    formFileUid: '',
    onlineStatus: true,
    directStatus: true,
    callStatus: true,
    freeStatus: true,
    price: 0,
    useStatus: true,
    rangeInfiniteStatus: true,
    startDate: '',
    endDate: '',
    images: [],
    dateRange: [],
    paymentTerm: 3,
    settingUnitStatus: 0,
    groupReservationStatus: false,
    continueStatus: false,
    pushSmsStatus: true,
    pushKakaoStatus: true,
    cardPayStatus: true,
    bankPayStatus: true,
    vbankPayStatus: false,
    shopId: '',
    shopKey: '',
    shopApiKey: '',
    shopApiIv: '',
    schedulePart: [],
    updateSchedule: [],
    reservationItemDay: {
      monUsable: true,
      tueUsable: true,
      wedUsable: true,
      thuUsable: true,
      friUsable: true,
      satUsable: false,
      sunUsable: false,
      holUsable: false,
      weekdayPriceType: 0,
      weekdayPrice: 0,
      saturdayPriceType: 0,
      saturdayPrice: 0,
      sundayPriceType: 0,
      sundayPrice: 0,
      holidayPriceType: 0,
      holidayPrice: 0,
    },
    clientFields: [],
    ranges: [],
    openRanges: [],
    itemHour: [],
    holidays: [],
    options: [],
    cancelPolicy: {
      clientCancelInfos: [],
      managerCancelInfos: [],
    },
    campList: [],
    managePolicy: {
      dayCount: 0,
      dayCountUse: false,
      weekCount: 0,
      weekCountUse: false,
      monthCount: 0,
      monthCountUse: false,
      possibleTermStatus: false,
      possibleStartTime: '00:00',
      possibleTermDay: 0,
      deadlineStatus: false,
      deadlineTermDay: 0,
      deadlineTermTime: '00:00',
    },
    discountPolicies: [],
    serviceTermsList: [],
    additionalGroups: [],
    inquiries: [],
    mainStatus: false,
  };
};

export const getReservationItemList = (params: any) => request({
  url: PATH,
  method: 'get',
  params: {
    ...params,
    page: params.page - 1,
  },
});

export const getReservationItemSimpleList = (params: any) => request({
  url: `${PATH}/calendar/list`,
  method: 'get',
  params: {
    ...params,
    page: params.page - 1,
  },
});

export const getReservationItemListByDraw = (categoryUid: string) => request({
  url: `${PATH}/${categoryUid}/list/draw`,
  method: 'get',
});

export const getReservationItem = (uid: string) => request({
  url: `${PATH}/${uid}`,
  method: 'get',
});

export const getReservationCalendar = (uid: string, params: any) => request({
  url: `${PATH}/${uid}/calendar`,
  method: 'get',
  params,
});

export const addReservationItem = (data: any) => request({
  url: PATH,
  method: 'post',
  timeout: 20000,
  data,
});

export const updateReservationItem = (uid: string, data: any) => request({
  url: `${PATH}/${uid}`,
  method: 'put',
  data,
});

export const deleteReservationItem = (uid: string) => request({
  url: `${PATH}/${uid}`,
  method: 'delete',
});
